import type { ApiResponse } from '@creator/sdk/creator-sdk';
import type { User } from '@creator/sdk/modules/account/account.model';
import { post as postApi } from '@creator/sdk/network/api-service';
import creatorSdk from '@src/services/creator-sdk';

export interface VisitApiRequestPayload {
    tokenName: string;
    userId: string;
}

export const visit = async (payload: VisitApiRequestPayload) => {
    const authIdToken = await creatorSdk.accountModule.getIdToken();
    const { data } = await postApi<ApiResponse<User>>(
        '/user/visit',
        payload,
        {
            Authorization: `Bearer ${authIdToken}`,
            'X-Firebase-AppCheck': '',
        },
        false
    );

    return data;
};
